<template>
  <div class="ui-carousel">
    <vue-slick-slider
      :arrows="arrows"
      :dots="dots"
      :infinite= "infinite"
      :vertical="true"
      :verticalSwiping="true"
      :slidesToShow="slidesToShow"
      :draggable="false"
      dotsClass="ui-carousel_dots"
    >
      <template #prevArrow>
        <div class="ui-carousel_arrow ui-carousel_arrow--prev">
        </div>
      </template>
      <template #nextArrow>
        <div class="ui-carousel_arrow ui-carousel_arrow--next">
        </div>
      </template>

      <slot>
        <div
          class="ui-carousel_slide"
          v-for="slideImg, i in slidesImg"
          :key="i"
        >
          <div class="ui-carousel_slide-inner">
            <img :src="slideImg.src" :alt="slideImg.alt" class="ui-carousel_img">
          </div>
        </div>
      </slot>

    </vue-slick-slider>
  </div>
</template>

<script>
export default {
  name: 'ui-carousel',

  props: {
    slidesImg: {
      type: Array,
      required: true,
    },
    arrows: {
      type: Boolean,
      default: true
    },
    dots: {
      type: Boolean,
      default: true,
    },
    infinite: {
      type: Boolean,
      default: true,
    },
    slidesToShow: {
      type: Number,
      default: 1,
    },
  },
}
</script>

<style lang="sass">
.ui-carousel
  width: 100%
  padding-right: px-em(30)
  max-height: 484px

  &--small
    .ui-carousel_slide
      height: px-em(161)

    .ui-carousel_arrow
      &.slick-prev,
      &.slick-next
        width: 28px
        height: 28px

      &.slick-prev
        top: px-em(21)

      &.slick-next
        bottom: px-em(21)

  .slick-list
    max-height: 484px

.ui-carousel_dots
  list-style: none
  padding: 0
  margin: 0
  position: absolute
  top: 50%
  right: 0
  transform: translateX(100%) translateY(-50%)

  li
    width: px-em(9)
    height: px-em(9)

    + li
      margin-top: px-em(15)

    &.slick-active button
      background-color: #E1E1E1

  button
    font-size: 0
    line-height: 0
    width: 100%
    height: 100%
    border-radius: 50%
    background-color: #7FB9BD

.ui-carousel_arrow
  &.slick-prev,
  &.slick-next
    width: px-em(42)
    height: px-em(42)
    border-radius: 50%
    background-color: #7FB9BD
    font-size: 1em
    right: initial
    left: 50%
    transform: translateX(-50%)
    z-index: 8
    opacity: .9
    transition: opacity .1s

    &::before
      content: ""
      font-size: 1em
      display: block
      position: absolute
      top: 0
      bottom: 0
      right: 0
      left: 0
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='26' fill='none' viewBox='0 0 16 26'%3E%3Cpath fill='%23fff' fill-rule='evenodd' d='m.93 7.417 6.363-6.364a1 1 0 0 1 1.414 0l6.364 6.364a1 1 0 0 1-1.414 1.414L9 4.174V24.44a1 1 0 1 1-2 0V4.174L2.343 8.831A1 1 0 1 1 .93 7.417Z' clip-rule='evenodd'/%3E%3C/svg%3E")
      background-repeat: no-repeat
      background-position: 50%
      background-size: px-em(14) px-em(24)

    &:hover
      background-color: #7FB9BD
      opacity: 1

  &.slick-prev
    top: px-em(33)
    bottom: initial

  &.slick-next
    bottom: px-em(33)
    top: initial

    &::before
      transform: rotate(180deg)

.slick-vertical .slick-slide
  line-height: 0 !important

.ui-carousel_slide
  width: 100%
  height: px-em(210)
  margin: 15px 0

.ui-carousel_slide-inner
  height: 100%
  overflow: hidden
  border-radius: px-em(20)

.ui-carousel_img
  min-width: 100%
  width: auto
  height: 100%
  // min-height: 100%
</style>
